import { render, staticRenderFns } from "./UserPreviousTodos.vue?vue&type=template&id=5c0df131&scoped=true&"
import script from "./UserPreviousTodos.vue?vue&type=script&lang=js&"
export * from "./UserPreviousTodos.vue?vue&type=script&lang=js&"
import style0 from "./UserPreviousTodos.vue?vue&type=style&index=0&id=5c0df131&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0df131",
  null
  
)

export default component.exports